<div class="row col-12 d-flex align-items-center justify-content-center">
    <div class="col-1 d-flex align-items-center justify-content-start">
        <button
            type="button"
            (click)="toggleSideMenu()"
            class="btn btn-primary toggle-menu d-flex"
        >
            <nb-icon icon="fa-bars"></nb-icon>
        </button>
    </div>

    <div class="col-2">
        <ng-template #leftComponent></ng-template>
    </div>

    <div class="col-6 offset-1">
        <ng-template #middleComponent></ng-template>
    </div>

    <div class="col-2 d-flex align-items-center justify-content-evenly">
        <ng-template #rightComponent></ng-template>
        <on-language-switcher></on-language-switcher>
    </div>
</div>
